import { render, staticRenderFns } from "./UploadingPageMobile.vue?vue&type=template&id=de28d558&scoped=true&"
import script from "./UploadingPageMobile.vue?vue&type=script&lang=js&"
export * from "./UploadingPageMobile.vue?vue&type=script&lang=js&"
import style0 from "./UploadingPageMobile.vue?vue&type=style&index=0&id=de28d558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de28d558",
  null
  
)

export default component.exports